import { Alert, Snackbar } from "@mui/material";
import { SyntheticEvent } from "react";
import { NotificationProps } from "../../interfaces/props/NotificationProps";

const CLICKAWAY = 'clickaway';

const Notification = ({ open, onClose, message, severity, position }: NotificationProps) => {
  const closeHandler = (event?: SyntheticEvent | Event, reason?: string) => {
    onClose();

    if (CLICKAWAY === reason) {
      return;
    }
  };

  return <Snackbar
    anchorOrigin={position ?? { vertical: 'top', horizontal: 'center' }}
    open={open}
    autoHideDuration={3000}
    onClose={closeHandler}
  >
    <Alert className='p-2' variant='filled' severity={severity} onClose={closeHandler}>{message}</Alert>
  </Snackbar>
};

export default Notification;
